import { AlertTriangle } from 'lucide-react';
import { Trans } from '@lingui/react/macro';
import { Button } from '@/common/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/common/components/ui/dialog';

interface CancelProductDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  productName: string;
  onConfirm: () => void;
}

export function CancelProductDialog({
  open,
  onOpenChange,
  productName,
  onConfirm,
}: CancelProductDialogProps) {
  function handleConfirm() {
    onConfirm();
    onOpenChange(false);
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <div className="flex items-start gap-4">
            <div className="flex size-10 shrink-0 items-center justify-center rounded-full bg-red-50">
              <AlertTriangle size={20} className="text-red-600" />
            </div>
            <div>
              <DialogTitle>
                <Trans>Cancel subscription?</Trans>
              </DialogTitle>
              <DialogDescription className="mt-1">
                <Trans>
                  &quot;{productName}&quot; will be cancelled at the end of the current billing
                  period.
                </Trans>
              </DialogDescription>
            </div>
          </div>
        </DialogHeader>

        <DialogFooter className="mt-2">
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            <Trans>Keep subscription</Trans>
          </Button>
          <Button variant="destructive" onClick={handleConfirm}>
            <Trans>Cancel subscription</Trans>
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
